import type { GatsbyBrowser } from 'gatsby'

import { loadMatomoAndTrack, trackPageView } from './src/tracking/matomo'
import { loadMyFonts } from './src/tracking/myfonts'
import {
  bootstrapCookieFirst,
  onCookieFirstServiceUpdate,
} from './src/tracking/cookieFirst'
import { loadLinkedIn } from './src/tracking/linkedIn'
import { loadFacebook } from './src/tracking/facebook'
import {
  loadGoogleAnalytics,
  trackGoogleAnalyticsPageView,
} from './src/tracking/analytics'
import { loadGoogleRemarketing } from './src/tracking/remarketing'
import { loadGoogleTagManager } from './src/tracking/google-tag-manager'

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = (ref) => {
  trackPageView(ref)
  trackGoogleAnalyticsPageView(ref.location)
}

export const onClientEntry: GatsbyBrowser['onClientEntry'] = (
  args,
  options
) => {
  if (process.env.NODE_ENV !== 'production' || process.env.GATSBY_FORCE_FONTS) {
    loadMyFonts()
    return
  }

  onCookieFirstServiceUpdate((accepted) => {
    if (accepted.includes('matomo')) {
      loadMatomoAndTrack(window.location)
    }
  })

  onCookieFirstServiceUpdate((accepted) => {
    if (accepted.includes('myfonts')) {
      loadMyFonts()
    }
  })

  onCookieFirstServiceUpdate((accepted) => {
    if (accepted.includes('facebook')) {
      loadFacebook()
    }
  })

  onCookieFirstServiceUpdate((accepted) => {
    if (accepted.includes('adwords_remarketing')) {
      loadGoogleRemarketing()
    }
  })

  onCookieFirstServiceUpdate((accepted) => {
    if (accepted.includes('linkedin_ads')) {
      loadLinkedIn()
    }
  })

  onCookieFirstServiceUpdate((accepted) => {
    if (accepted.includes('google_analytics')) {
      loadGoogleAnalytics()
    }
  })

  onCookieFirstServiceUpdate((accepted) => {
    if (accepted.includes('google_tag_manager')) {
      loadGoogleTagManager()
    }
  })

  bootstrapCookieFirst()
}
